var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.244865,
    y: 0.244865,
    width: 35.5103,
    height: 35.5103,
    rx: 10.0408,
    fill: "url(#paint0_linear_1365_9510)",
    stroke: "#F6921E",
    strokeWidth: 0.489731
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1365_9510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5187 14.9399L21.7018 13.9493L18.6531 7.77204C18.3864 7.2317 17.6134 7.23144 17.3465 7.77204L14.2979 13.9493L7.48093 14.9399C6.88475 15.0265 6.64531 15.7616 7.07718 16.1825L12.0099 20.9908L10.8454 27.7802C10.7985 28.0536 10.9108 28.3297 11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L17.9998 25.3428C24.6379 28.8325 24.1819 28.6319 24.4361 28.6319C24.8851 28.6319 25.2308 28.2271 25.1542 27.7802L23.9897 20.9908L28.9225 16.1825C29.3539 15.7619 29.1154 15.0266 28.5187 14.9399Z",
    fill: "#F7AC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 7.36594C17.722 7.36594 17.469 7.52389 17.3465 7.77204L14.2978 13.9493L7.48093 14.9399C6.88475 15.0265 6.64531 15.7616 7.07718 16.1825L12.0099 20.9908L10.8454 27.7802C10.7985 28.0536 10.9108 28.3297 11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L17.9998 25.3428H17.9998V7.36594Z",
    fill: "#F2D422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48093 14.9398C6.88475 15.0265 6.64531 15.7616 7.07718 16.1825L12.0099 20.9908L10.8454 27.7802C10.7985 28.0536 10.9108 28.3297 11.1353 28.4928C11.3596 28.6557 11.657 28.6772 11.9025 28.5482L17.9998 25.3427C24.6379 28.8325 24.1819 28.6319 24.4361 28.6319C24.5871 28.6319 24.7374 28.585 24.8643 28.4928L14.2978 13.9493L7.48093 14.9398Z",
    fill: "#F7AC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.629 20.1522C9.3451 15.0016 9.57222 15.2777 9.50132 15.0105C9.47246 14.9032 9.46654 14.7784 9.49792 14.6467L7.48093 14.9398C6.88475 15.0265 6.64531 15.7616 7.07718 16.1825L12.0099 20.9908L10.8454 27.7802C10.7985 28.0536 10.9108 28.3297 11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L13.6952 27.6057C13.5108 27.4396 13.4219 27.1896 13.4645 26.9416L14.629 20.1522Z",
    fill: "#F48B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07694 16.1825L12.0097 20.9908L10.8452 27.7802C10.7983 28.0536 10.9106 28.3297 11.135 28.4928C11.3594 28.6558 11.6567 28.6773 11.9022 28.5482L17.9995 25.3428C24.6376 28.8325 24.1817 28.6319 24.4358 28.6319C24.8848 28.6319 25.2306 28.2271 25.1539 27.7802L23.9894 20.9908L6.89251 15.4357C6.80733 15.741 6.8926 16.0029 7.07694 16.1825Z",
    fill: "#F2D422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07694 16.1825L12.0097 20.9908L10.8452 27.7802C10.7983 28.0536 10.9106 28.3297 11.135 28.4928C11.3594 28.6558 11.6567 28.6773 11.9022 28.5482L13.695 27.6057C13.5105 27.4396 13.4217 27.1896 13.4642 26.9416L14.6287 20.1522L11.239 16.8479L6.89251 15.4357C6.80733 15.741 6.8926 16.0029 7.07694 16.1825Z",
    fill: "#EFB616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8455 27.7802C10.7986 28.0535 10.9109 28.3297 11.1353 28.4928C11.3597 28.6557 11.657 28.6772 11.9025 28.5482L17.9999 25.3427C24.6379 28.8325 24.182 28.6319 24.4361 28.6319C24.8851 28.6319 25.2309 28.2271 25.1542 27.7802L23.9897 20.9908L28.9226 16.1825C29.1211 15.9889 29.1925 15.6994 29.1069 15.4357L12.01 20.9908L10.8455 27.7802Z",
    fill: "#F7AC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8455 27.7802C10.7986 28.0536 10.9109 28.3297 11.1353 28.4928C11.3597 28.6558 11.657 28.6773 11.9025 28.5482L13.6953 27.6057C13.5108 27.4396 13.422 27.1896 13.4645 26.9416L14.6291 20.1522L14.6195 20.1429L12.01 20.9908L10.8455 27.7802Z",
    fill: "#F48B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9025 28.5482L17.9998 25.3428C24.6379 28.8325 24.1819 28.6319 24.436 28.6319C24.8851 28.6319 25.2308 28.2271 25.1541 27.7802L23.9897 20.9908L28.9225 16.1825C29.3538 15.7619 29.1153 15.0266 28.5187 14.9398L21.7017 13.9493L11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482Z",
    fill: "#F2D422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1069 15.4357L17.9998 19.0446L11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L17.9998 25.3428C24.6379 28.8325 24.1819 28.6319 24.436 28.6319C24.8851 28.6319 25.2308 28.2271 25.1541 27.7802L23.9897 20.9908L28.9225 16.1825C29.121 15.9889 29.1925 15.6994 29.1069 15.4357Z",
    fill: "#F7AC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9897 20.9908L17.9998 19.0446L11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L17.9998 25.3428C24.6379 28.8325 24.1819 28.6319 24.436 28.6319C24.8851 28.6319 25.2308 28.2271 25.1541 27.7802L23.9897 20.9908Z",
    fill: "#F2D422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L17.9998 25.3428C24.6379 28.8325 24.1819 28.6319 24.436 28.6319C24.5871 28.6319 24.7374 28.585 24.8643 28.4928L17.9998 19.0446L11.1353 28.4928Z",
    fill: "#F7AC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 19.0446L17.9998 19.0446L11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L17.9998 25.3428H17.9998V19.0446Z",
    fill: "#F2D422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.836 24.7756L11.1353 28.4928C11.3596 28.6558 11.657 28.6773 11.9025 28.5482L13.6952 27.6057C13.5108 27.4396 13.4219 27.1896 13.4645 26.9416L13.836 24.7756Z",
    fill: "#EFB616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1365_9510",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643D0F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1365_9510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2857,
    height: 22.2857,
    fill: "white",
    transform: "translate(6.85693 6.85715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishStep);
export default __webpack_public_path__ + "static/media/finish-step.51515ed415ee0e555194d31bfc1d37a3.svg";
export { ForwardRef as ReactComponent };